export default __webpack_public_path__ + "static/media/Juneau-Bold.fef4d2b7.ttf";